<router-outlet></router-outlet>

<div #contextMenuViewRef>
    <div class="context-menu-origin" #contextMenuOrigin></div>
</div>